// Fix this file, do not use any as the type
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios'
import AxiosInstance from 'config/apiServiceApiGateway'
import {
  getAvailableStaff,
  updateStaffAvailability,
} from 'features/Order/services/staffAvailability'

const { REACT_APP_BASE_URL_API } = process.env
const baseUrl = REACT_APP_BASE_URL_API

export const postNewDriver_Driver = (data: any): any =>
  AxiosInstance.Post({
    url: `/staff-management/internal/v1/staff`,
    data,
  })

export const putDriver_Driver = (id: any, data: any): any =>
  AxiosInstance.Put({
    url: `/staff-management/internal/v1/staff/${id}`,
    data,
  })

export const getDriverList_Driver = (query = ''): any =>
  axios.get(`${baseUrl}/api/driver-admin${query}`)

export const putDriverActive_Driver = (id: any, dataStatus: any): any =>
  axios.put(`${baseUrl}/api/driver-admin/${id}/active`, dataStatus)

export const postDriverActiveRole_Driver = (id: any, payload: any): any =>
  axios.post(`${baseUrl}/api/staff-management/staff/${id}/role`, payload)

export const putDriverActive_Driververify = (id: any, dataStatus: any): any =>
  updateStaffAvailability(id, dataStatus?.is_available ?? true)

export const getDriverByRole = (locationId: any, role: any, _query = ''): any =>
  getAvailableStaff(locationId, role)

export const getListHubStaffRole = (locationType: any): any =>
  axios.get(`${baseUrl}/api/driver-admin/role`, {
    params: {
      locationType: locationType || 'HUB',
    },
  })

export const getListEmploymentType = (): any =>
  AxiosInstance.Get({
    url: '/staff-management/internal/:version/staff/employment-types',
    version: 'v1',
  })

export const exportDriver = (): any =>
  axios.get(`${baseUrl}/api/driver-admin/export`, {
    params: {
      locationType: 'HUB',
    },
  })

export const downloadTemplate = (): any => axios.get(`${baseUrl}/api/driver-admin/csv/template`)

export const getListVendorStaff = (): any =>
  axios.get(`${baseUrl}/api/staff-management/staff-vendors/list`)

export const getDepartementList = (): any =>
  axios.get(`${baseUrl}/api/staff-management/admin/all-department-list`)

export const getLocations = (locationType: any, name: any): any =>
  axios.get(`${baseUrl}/api/location`, {
    params: {
      type: locationType || 'HUB',
      name,
    },
  })

export const fetchStaffList = (data: any): any =>
  AxiosInstance.Post({
    url: '/staff-management/internal/:version/staff/get-with-pagination',
    version: 'v1',
    data,
  })
